import { DialogWithForm } from '@strata/react-dialog';
import { FileUploadFormik } from '@strata/react-file-upload';
import { TextAreaFormik } from '@strata/react-inputs';
import { validationStrings } from '@strata/strata-ui-strings';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { handleError } from 'services/ErrorManagement';
import { put } from 'services/Http';
import { downloadPolicyFile, removePolicyFile, uploadPolicyFiles } from 'services/PolicyFiles';

export const RequestChangesDialog = ({
    isOpen,
    fetchPolicy,
    onSecondaryButtonClick,
    payerId,
    draftId,
}) => (
    <Formik
        initialValues={{ attachments: [] }}
        enableReinitialize
        validationSchema={Yup.object({
            change: Yup.string().required(validationStrings.requiredField.errorMessage),
            attachments: Yup.array(),
        })}
        onSubmit={async ({ change, attachments }, { resetForm }) => {
            try {
                await put(`/clinicalpolicy/admin/${payerId}/drafts/${draftId}/changes`, {
                    internal: true,
                    change,
                    attachments: attachments.map((file) => file.name),
                });
                await fetchPolicy();
                resetForm();
                onSecondaryButtonClick();
            } catch (err) {
                handleError('Error requesting policy changes.', err);
            }
        }}
    >
        {(formik) => (
            <DialogWithForm
                dialogTitle="Request Changes"
                primaryButtonLabel="Send Request"
                secondaryButtonLabel="Cancel"
                isOpen={isOpen}
                onSecondaryButtonClick={() => {
                    formik.handleReset();
                    onSecondaryButtonClick();
                }}
                isPrimaryButtonDisabled={!(formik.dirty && formik.isValid) || formik.isSubmitting}
                dialogContent={
                    <>
                        <p className="margin__bottom--large">
                            You can request changes from your FMH team. They will be notified and
                            asked to review this policy.
                        </p>
                        <TextAreaFormik id="change" label="Change Description" required />
                        <FileUploadFormik
                            id="attachments"
                            label="Clinical Documents"
                            onAddFiles={(files) => uploadPolicyFiles({ files, payerId, draftId })}
                            onRemoveFile={(filename) =>
                                removePolicyFile({ filename, payerId, draftId })
                            }
                            onFileClick={(filename) =>
                                downloadPolicyFile({
                                    filename,
                                    payerId,
                                    draftId,
                                })
                            }
                        />
                    </>
                }
            />
        )}
    </Formik>
);

RequestChangesDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    fetchPolicy: PropTypes.func.isRequired,
    onSecondaryButtonClick: PropTypes.func.isRequired,
    payerId: PropTypes.string.isRequired,
    draftId: PropTypes.string.isRequired,
};
